(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    //   document.addEventListener("DOMContentLoaded", () => {
//   const container = document.querySelector(".blog-post-content--article.blog-post-content--hide-inline-images");
//   if (!container) return;

//   const firstImg = container.querySelector("img, picture");
//   if (firstImg) {
//     firstImg.style.display = "none";
//   }
// });
  } catch(e) { console.error(e); }
})();

})();
